import { convertBase64ToHtmlImage } from './convert-base64-to-html-image.util';

export type GenerateImageFromAnotherConfig = {
  container?: Record<'width' | 'height', number>;
  image?: Record<'width' | 'height', number>;
  hasTransparency?: boolean;
};

export const generateImageFromAnother = async (imageBase64: string, config: GenerateImageFromAnotherConfig = {}): Promise<string> => {
  const image = await convertBase64ToHtmlImage(imageBase64);

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('Erro ao obter contexto do canvas');
  }

  // 🖼️ Define o tamanho do canvas (padrão: tamanho da imagem original)
  const canvasWidth = config.container?.width || image.width;
  const canvasHeight = config.container?.height || image.height;
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;

  // 🎨 Preenche o fundo
  if (config.hasTransparency) {
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);
  } else {
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvasWidth, canvasHeight);
  }

  // 📌 Define o tamanho e a posição da imagem
  const imageWidth = config.image?.width || image.width;
  const imageHeight = config.image?.height || image.height;
  const imagePositionX = (canvasWidth - imageWidth) / 2;
  const imagePositionY = (canvasHeight - imageHeight) / 2;
  ctx.drawImage(image, imagePositionX, imagePositionY, imageWidth, imageHeight);

  // 📸 Retorna a imagem gerada em Base64
  return canvas.toDataURL('image/png');
};
